import * as React from 'react';
import type { SVGProps } from 'react';

const IconQuote = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 21" {...props}>
    <path
      d="M22.655 16.336c0 2.552-2 4.62-4.69 4.62-2.896 0-4.62-2.137-4.62-5.24 0-5.725 4.62-12 10.138-14.76l.483.76C21 3.99 18.035 7.507 18.035 11.783c2.482.07 4.62 1.862 4.62 4.552Zm-13.31 0c0 2.552-2 4.62-4.69 4.62-2.896 0-4.62-2.137-4.62-5.24 0-5.725 4.62-12 10.138-14.76l.482.76C7.69 3.99 4.725 7.507 4.725 11.783c2.482.07 4.62 1.862 4.62 4.552Z"
      fill="currentColor"
    />
  </svg>
);

export default IconQuote;
